import { ExternalLink } from "@octopusdeploy/design-system-components";
import { useOctopusFeatureToggle } from "~/hooks/useOctopusFeatureToggle";
import InternalLink from "../Navigation/InternalLink/InternalLink";
import { AnsiColors } from "./AnsiColors";
import { isInternalLinkPart, isTextPart, parseMarkdownLinks } from "./parseLinks";
interface TextWithLinksProps {
    message: string;
    parseColorCodes?: boolean;
}
export function TextWithLinks(props: TextWithLinksProps) {
    const parsed = parseMarkdownLinks(props.message);
    const parseAnsiColors = useOctopusFeatureToggle("ansi-colors", false) && props.parseColorCodes;
    // Faster rendering if there are no links
    if (parsed.length == 1 && isTextPart(parsed[0])) {
        return parseAnsiColors ? <AnsiColors text={props.message}/> : props.message;
    }
    return parsed.map((part, index) => {
        if (isTextPart(part)) {
            return <span key={index}>{part.content}</span>;
        }
        if (isInternalLinkPart(part)) {
            return (<InternalLink key={index} to={part.internalUrl}>
                    {part.text}
                </InternalLink>);
        }
        return (<ExternalLink key={index} href={part.externalUrl}>
                {part.text}
            </ExternalLink>);
    });
}
